import type {
  SimulateEventResponse,
  TestPatientState,
} from "@care-by-ella/contracts";
import { API_BASE, apiFetch, tenantHeader, withCredentials } from "./api";

// TES-298 — simulate & observe for TEST patients. Same session-cookie auth
// as clinician-api; the API 404s unless the patient has isTest=true.

function headers(extra?: Record<string, string>): Record<string, string> {
  return { ...tenantHeader(), ...extra };
}

async function jsonOr401<T>(res: Response): Promise<T> {
  if (res.status === 401) {
    const { UnauthorizedError } = await import("./clinician-api");
    throw new UnauthorizedError();
  }
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return (await res.json()) as T;
}

export async function fetchTestEvents(): Promise<{ events: string[] }> {
  const res = await apiFetch(`${API_BASE}/employee-api/v1/test-mode/events`, {
    headers: headers(),
    ...withCredentials,
  });
  return jsonOr401(res);
}

export async function fetchTestState(
  patientId: string,
): Promise<TestPatientState> {
  const res = await apiFetch(
    `${API_BASE}/employee-api/v1/patients/${patientId}/test-state`,
    { headers: headers(), ...withCredentials },
  );
  return jsonOr401(res);
}

export async function simulateEvent(
  patientId: string,
  event: string,
): Promise<SimulateEventResponse> {
  const res = await apiFetch(
    `${API_BASE}/employee-api/v1/patients/${patientId}/simulate-event`,
    {
      method: "POST",
      headers: headers({ "Content-Type": "application/json" }),
      body: JSON.stringify({ event }),
      ...withCredentials,
    },
  );
  return jsonOr401(res);
}
